import {
  Component,
  ChangeDetectionStrategy,
  Input,  
} from '@angular/core';
import { PlanPropertyComponent } from '../../../plans/shared/models/plan-property-component';
import { FiscalYear } from 'app/internal/shared';
import { SetSelectedFiscalYearAction } from 'app/internal/property/property-store/property.actions';
import { AppState } from 'app/app.reducers';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

@Component({
  selector: 'sp-review-anticipated-expenditures',
  templateUrl: './review-anticipated-expenditures.component.html',
  styleUrls: ['./review-anticipated-expenditures.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ReviewAnticipatedExpendituresComponent {

  @Input() anticipatedExpenditures: PlanPropertyComponent[];
  @Input() previousFiscalYear: FiscalYear;
  @Input() selectedYearDisplay: string;

  extendLifeComponents: string[] = [];
  updateCurrentYear: boolean = false;

  constructor(private store: Store<AppState>, private router: Router) { }

  trackByComponentId(index, item): string {
    return item != null ? item.id : null;
  }

  isReplacementDelayed(componentId: string) {
    const component = this.extendLifeComponents.find(x => x === componentId);
    return component != null;
  }

  componentReplacementChanged(componentId: string, isDelay: boolean) {
    const delayIndex = this.extendLifeComponents.indexOf(componentId);
    if (isDelay && delayIndex < 0) {
      this.extendLifeComponents.push(componentId);
    } else if (!isDelay && delayIndex >= 0) {
      this.extendLifeComponents.splice(delayIndex, 1);
    }
  }

  setForAll(isDelay: boolean) {
    if (isDelay) {
      // add all to list
      this.extendLifeComponents = [];
      this.anticipatedExpenditures.forEach(component => {
        this.extendLifeComponents.push(component.propertyComponentId);
      });
    } else {
      // remove all from list
      this.extendLifeComponents = [];
    }
  }

  editComponent(component: PlanPropertyComponent) {
    this.store.dispatch(new SetSelectedFiscalYearAction(this.previousFiscalYear));
    this.router.navigate(['/useraccount/components/' + component.propertyComponentId]);
  }

  getExtendedLifeComponents() {
    return this.extendLifeComponents;
  }

  getUpdateCurrentYear() {
    return this.updateCurrentYear;
  }
}
